import type {
  PerformancePageOverview,
  PerformanceResponse,
} from 'api/new-analytics/types';

export function resolvePreviewPerformanceOverview(
  profileType: 'general' | 'profile',
  data: PerformanceResponse | undefined,
): PerformancePageOverview | undefined {
  if (!data) {
    return undefined;
  }

  if (profileType === 'general') {
    return data.totals;
  }

  return data.pages[0]?.overview;
}

export function isPreviewPerformanceDataMissing(
  profileType: 'general' | 'profile',
  data: PerformanceResponse | undefined,
): boolean {
  if (!data) {
    return true;
  }

  if (profileType === 'general') {
    return false;
  }

  return data.pages.length === 0;
}
